export const toBoolean = (target) => {
  if (!target) return false
  if (target === true) return true
  if (target === 'true') return true
  if (target === '1') return true
  if (target === 1) return true
  return false
}
